<template>
    <div class="my-filter-content">
        <div class="my-fc-search">
            <div class="my-fc-search-top">
                <vxe-input
                    v-model="option.data.sVal"
                    placeholder="搜索"
                    suffix-icon="fa fa-search"
                    @keyup="searchEvent"
                ></vxe-input>
            </div>
            <div class="my-fc-search-content">
                <template v-if="valList.length">
                    <ul class="my-fc-search-list my-fc-search-list-head">
                        <li class="my-fc-search-item">
                            <vxe-checkbox
                                v-model="isAll"
                                :indeterminate="isIndeterminate"
                                @change="changeAllEvent"
                                >全选</vxe-checkbox
                            >
                        </li>
                    </ul>
                    <ul class="my-fc-search-list my-fc-search-list-body">
                        <li
                            class="my-fc-search-item"
                            v-for="(item, sIndex) in valList"
                            :key="sIndex"
                        >
                            <vxe-checkbox
                                v-model="item.checked"
                                @change="changeItemEvent"
                                >{{ item.value }}</vxe-checkbox
                            >
                        </li>
                    </ul>
                </template>
                <template v-else>
                    <div class="my-fc-search-empty">无匹配项</div>
                </template>
            </div>
        </div>
        <div class="my-fc-footer">
            <vxe-button size="mini" status="primary" @click="confirmFilterEvent"
                >确认</vxe-button
            >
            <vxe-button size="mini" @click="resetFilterEvent">重置</vxe-button>
        </div>
    </div>
</template>

<script>
import XEUtils from 'xe-utils'
import Vue from 'vue'
export default {
    name: 'FilterContent',
    props: {
        params: Object
    },
    data() {
        return {
            size: 'mini', // 被所有子组件继承 size
            isAll: true,
            isIndeterminate: false,
            option: null,
            colValList: [],
            valList: []
        }
    },
    watch: {
        params() {
            this.load()
        },
        colValList() {
            this.searchEvent()
        }
    },
    created() {
        this.load()
        this.searchEvent()
    },
    methods: {
        load() {
            // filters 可以配置多个，实际只用一个就可以满足需求了
            const { $columnIndex, $table, column } = this.params
            const { fullData } = $table.getTableData()
            const option = column.filters[0]
            let { vals } = option.data
            var currentproperty = column.property
            var lastproperty = $table.tableColumn[$columnIndex - 1].property
            var currentarray = Object.keys(
                XEUtils.groupBy(fullData, currentproperty)
            )
            currentarray = currentarray.filter((a) => a != '' && a != undefined)
            var grouparray = []
            if (
                currentproperty == 'amountSource' ||
                currentproperty == 'cloudSupplyAmount' ||
                currentproperty == 'otherOrganType'
            ) {
                grouparray = currentarray
            } else {
                currentarray.forEach((item) => {
                    if (item == undefined) {
                        grouparray.push('')
                    } else {
                        fullData.forEach((data) => {
                            if (data[lastproperty] == undefined) {
                                if (
                                    data[currentproperty] == item &&
                                    !grouparray.includes(item)
                                ) {
                                    grouparray.push(item)
                                }
                            } else if (data[currentproperty] === '') {
                                if (
                                    data[currentproperty] == item &&
                                    !grouparray.includes(data[lastproperty])
                                ) {
                                    grouparray.push(data[lastproperty])
                                }
                            } else {
                                if (data[currentproperty] == item) {
                                    if (currentproperty == '门店收银方式名称') {
                                        let count = fullData.filter(
                                            (s) => s[currentproperty] === item
                                        ).length

                                        if (
                                            !grouparray.includes(
                                                item +
                                                    '~' +
                                                    data[lastproperty] +
                                                    '(' +
                                                    count +
                                                    ')'
                                            )
                                        ) {
                                            grouparray.push(
                                                item +
                                                    '~' +
                                                    data[lastproperty] +
                                                    '(' +
                                                    count +
                                                    ')'
                                            )
                                        }
                                    } else {
                                        if (
                                            !grouparray.includes(
                                                item + '~' + data[lastproperty]
                                            )
                                        ) {
                                            grouparray.push(
                                                item + '~' + data[lastproperty]
                                            )
                                        }
                                    }
                                }
                            }
                        })
                    }
                })
            }

            const colValList = grouparray.map((val) => {
                if (vals.length == 0) {
                    return {
                        checked: true,
                        value: val
                    }
                } else {
                    if (val.includes('~')) {
                        var valarray = val.split('~')
                        return {
                            checked:
                                vals.includes(valarray[0]) ||
                                vals.includes(valarray[1]),
                            value: val
                        }
                    } else {
                        let isChecked = vals.includes(val)
                        var temp = vals.map((item) => item.value)
                        if (temp.length > 0) {
                            isChecked = vals.includes(val) || temp.includes(val)
                        }
                        return {
                            checked: isChecked,
                            value: val
                        }
                    }
                }
            })
            this.option = option
            this.colValList = colValList
            this.valList = colValList
        },
        searchEvent() {
            const { option, colValList } = this
            this.valList = option.data.sVal
                ? colValList.filter(
                      (item) => item.value.indexOf(option.data.sVal) > -1
                  )
                : colValList
            this.updateCheckStatus()
        },
        changeAllEvent() {
            const { isAll, option } = this
            this.valList.forEach((item) => {
                item.checked = isAll
            })
            this.isIndeterminate = false
        },
        updateCheckStatus() {
            const { valList } = this
            const isAll = valList.every((item) => item.checked)
            this.isAll = isAll
            this.isIndeterminate =
                !isAll && valList.some((item) => item.checked)
        },
        changeItemEvent() {
            this.updateCheckStatus()
        },
        confirmFilterEvent(evnt) {
            const { params, option, valList } = this
            const { data } = option
            const { $panel } = params
            var temp = valList
                .filter((item) => item.checked)
                .map((item) => item.value)
            data.vals = []
            if (temp.length > 0) {
                temp.forEach((item) => {
                    if (item.includes('~')) {
                        var itemarray = item.split('~')
                        if (itemarray[0] != '') {
                            if (
                                params.column.property == 'oppositeSubjectName'
                            ) {
                                data.vals.push(itemarray[1])
                            } else {
                                data.vals.push(itemarray[0])
                            }
                        } else {
                            data.vals.push(itemarray[1])
                        }
                    } else {
                        data.vals.push(item)
                    }
                })
                option.checked = true
            } else {
                this.colValList.forEach((item) => {
                    if (item.value.includes('~')) {
                        var itemarray = item.value.split('~')
                        if (itemarray[0] != '') {
                            if (
                                params.column.property == 'oppositeSubjectName'
                            ) {
                                data.vals.push(itemarray[1])
                            } else {
                                data.vals.push(itemarray[0])
                            }
                        } else {
                            data.vals.push(itemarray[1])
                        }
                    } else {
                        data.vals.push(item)
                    }
                })
                option.checked = false
            }

            $panel.changeOption(evnt, true, option)
            $panel.confirmFilter()
        },
        resetFilterEvent() {
            const { $panel } = this.params
            $panel.resetFilter()
        }
    }
}
</script>

<style>